import styled from 'styled-components';

const MsgContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 1em;
  margin: 1em;
  border: 2px dotted ${props => props.theme.colors.lightGray};
  border-radius: ${props => props.theme.utils.borderRadius};
  span {
    color: ${props => props.theme.colors.lightGray};
    font-weight: bold;
  }
`;

export default styled(MsgContainer)``;
